module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"ru":{"traffic_lights":"Светофоры","pdk":"Камеры ПДК","road_engineering":"Дорожная техника","public_transport":"Общественный транспорт","events":"События"},"en":{"traffic_lights":"Traffic lights","pdk":"PDK cameras","road_engineering":"Road engineering","public_transport":"Public transport","events":"Events"}}')
  delete Component.options._Ctor
}
